let mmOf1 = 0
export function get1MM() {
  if (mmOf1) {
    return mmOf1
  }

  const div = document.createElement('div')
  div.className = 'osize-elem'
  div.setAttribute('style', 'width:1mm;height:1mm;')
  document.body.appendChild(div)
  mmOf1 = div.getBoundingClientRect().width;
  document.body.removeChild(div)
  return mmOf1
}

export function mm2px(size: number) {
  return size * get1MM()
}

export function px2mm(size: number) {
  return size / get1MM()
}